import Modal from "@mui/material/Modal";
import React, {useEffect, useState} from "react";
import {
  IconButton, Stack, Typography
} from "@mui/material";
import {IconX} from "@tabler/icons-react";
import {VarForm} from "../vars/VarForm";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "280px",
  maxWidth: "sm",
  width: "90%",
  maxHeight: "80vh",
  bgcolor: 'background.paper',
  borderRadius: 0,
  border: '0px solid #000',
  boxShadow: 24,
  p: 3,
  overflowY: "auto"
};

//Selected var is index
export const CreateDynamicRouteVarModal = ({open, handleClose, selectedRoute, selectedVar, node, onUpdateNode, project}) => {
  const [selectedParam, setSelectedParam] = useState(null);

  useEffect(() => {
    if (selectedVar >= 0) {
      const route = node?.routes?.dynamic?.find(r => r.id === selectedRoute);
      if (route) {
        const params = route?.data?.set_vars || [];
        const selectedParam = params[selectedVar];
        setSelectedParam(selectedParam || null);
      }
    }
  }, [selectedVar, selectedRoute, node, open])

  const onSubmit = (param) => {
    const newNode = {...node};
    const route = newNode?.routes?.dynamic?.find(r => r.id === selectedRoute);
    const params = route?.data?.set_vars || [];

    if (selectedVar !== null && selectedVar !== undefined && selectedVar >= 0) {
      params[selectedVar] = {...param};
    } else {
      params.push({...param});
    }
    newNode.routes.dynamic = newNode?.routes?.dynamic?.map(i => {
      if (i?.id === selectedRoute) {
        return {...i, data: {...i.data, set_vars: params}}
      }
      return {...i};
    });
    onUpdateNode(newNode);
    setSelectedParam(null);
    handleClose();
  }

  const onDelete = () => {
    const newNode = {...node}
    const route = newNode?.routes?.dynamic?.find(r => r.id === selectedRoute);

    const params = (route?.data?.set_vars || []).filter((p, ind) => ind !== selectedVar);
    newNode.routes.dynamic = newNode?.routes?.dynamic?.map(i => {
      if (i?.id === selectedRoute) {
        return {...i, data: {...i.data, set_vars: params}}
      }
      return {...i};
    });
    onUpdateNode(newNode);
    setSelectedParam(null);
    handleClose();
  }

  const onClose = () => {
    setSelectedParam(null);
    handleClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={2} sx={style}>
        <Stack direction={"row"} gap={1} justifyContent={"space-between"} alignItems={"center"}>
          <Typography variant={"h4"} fontWeight={600}>{selectedVar ? "Edit" : "Create"} Var</Typography>
          <IconButton onClick={onClose}>
            <IconX/>
          </IconButton>
        </Stack>
       <VarForm
        handleClose={onClose}
        onDelete={onDelete}
        onSubmit={onSubmit}
        selectedParam={selectedParam}
        node={node} project={project}
       />
      </Stack>
    </Modal>
  )
}
